export enum ErrorTexts {
    COMPONENT_EXISTS = 'Component already exists',
    OUT_OF_EMAIL_LIMIT = 'Owner email has reached the limit of components'
}